var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.debug === 'true' || _vm.debug === true)?_c('span',[_vm._v(_vm._s(_vm.version))]):_vm._e(),(
    _vm.$localStorageService.can('DX_14_ver_paciente') ||
      _vm.$localStorageService.can('DX_13_ver_paciente') ||
      _vm.$localStorageService.can('DX_12_ver_paciente') ||
      _vm.$localStorageService.can('DX_10_ver_paciente')
  )?_c('router-link',{attrs:{"to":{ name: 'paciente', params: { id: _vm.data.item.idPaciente } }}},[(
      _vm.resource.idEstatusSolicitud === 1 &&
        _vm.$localStorageService.can('DX_13_cambio_solicitud') && _vm.data.item.renegociar == true
    )?_c('p',{staticClass:"letraColorAzulPrincipal letraEstiloNegrita"},[_vm._v(" "+_vm._s(_vm.data["item"].nombrePaciente)+" ")]):_c('p',{staticClass:"letraColorAzulPrincipal letraEstiloNegrita"},[_vm._v(" "+_vm._s(_vm.data.item.nombrePaciente)+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }